import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';

// MSAL configuration
const msalConfig = {
    auth: {
        clientId: 'a21fac3f-8ff7-49c1-b650-7eaf0561c54b', // Replace with your Office 365 client ID
        authority: 'https://login.microsoft.com/1181d7b0-21cb-4658-82ff-083d36b8de45', // Replace with your tenant ID
        redirectUri: 'http://localhost:3000', // Replace with your redirect URI
    },
};

const msalInstance = new PublicClientApplication(msalConfig);

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Customize your primary color
    },
    secondary: {
      main: '#dc004e', // Customize your secondary color
    },
  },
});

// Register Service Worker for PWA installation
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Register the Firebase messaging service worker which now includes PWA functionality
    // This ensures both Firebase messaging and PWA installation work together
    navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' })
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New service worker available. Refresh to update.');
            }
          });
        });
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

// Handle PWA installation prompt
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later
  deferredPrompt = e;
  console.log('PWA installation prompt available');
  
  // Optionally, show a custom install button
  // You can dispatch a custom event or update UI here
  window.dispatchEvent(new CustomEvent('pwa-install-available'));
});

// Handle successful installation
window.addEventListener('appinstalled', () => {
  console.log('PWA installed successfully');
  deferredPrompt = null;
  // Optionally, show a success message or track analytics
});

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </MsalProvider>,
  document.getElementById('root')
);
